const format = (iso, timeZone, options) =>
  new Date(iso).toLocaleString("en-US", { ...options, ...(timeZone ? { timeZone } : {}) });

const TIME = { hour: "numeric", minute: "2-digit" };

export const showTimeLabel = (startTime, doorTime, timeZone) => {
  if (!startTime) return null;

  const parts = [
    format(startTime, timeZone, { weekday: "short", month: "short", day: "numeric", year: "numeric" }),
    format(startTime, timeZone, TIME),
  ];
  if (doorTime) parts.push(`Doors ${format(doorTime, timeZone, TIME)}`);
  return parts.join(" · ");
};

export const showDateLabel = (iso, timeZone) =>
  format(iso, timeZone, { month: "short", day: "numeric", year: "numeric" });
